import { ComponentList } from "../app/models/ComponentList";
import {
  EVENT_SALE,
  NEWS_PAGE,
  GIFT_CARD_ACTIVE,
  THREE_STEP,
  CALENDAR_SALE,
  BIRTHDAY_RESERVATION,
  PASSES_SALE,
  EXERCISE_SCHEDULE,
  LIMITED_TICKET_SHAPE,
  LIMITED_TICKET_GROUP,
  LIMITED_TICKET_COLOR,
  MAIN_APP,
} from "../app/routes";

export const getDefaultLink = (componentList: ComponentList[]): string => {
  if (!componentList || componentList.length === 0) {
    return MAIN_APP;
  }

  const activeComponent = componentList.find((item) => item.active);
  if (activeComponent) {
    switch (activeComponent.id) {
      case "EventSaleActive":
        return EVENT_SALE;
      case "NewsActive":
        return NEWS_PAGE;
      case "GiftCardActive":
        return GIFT_CARD_ACTIVE;
      case "StepByStepSaleActive":
        return THREE_STEP;
      case "StepByStepSaleActiveV2":
        return CALENDAR_SALE;
      case "BirthDaysActive":
        return BIRTHDAY_RESERVATION;
      case "PassSale":
        return PASSES_SALE;
      case "Calendar":
        return EXERCISE_SCHEDULE;
      case "Shapes":
        return LIMITED_TICKET_SHAPE;
      case "Groups":
        return LIMITED_TICKET_GROUP;
      case "Colors":
        return LIMITED_TICKET_COLOR;
      default:
        return MAIN_APP;
    }
  }
  return MAIN_APP;
};
